// extracted by mini-css-extract-plugin
module.exports = {"cell":"LkPfr","highlight":"PP1mB","edge":"ozi6H","truncate":"oCNmf","inner":"cDsuY","breakWord":"_3WRO2","slim":"_2nBz-"};